import API from "./api";

export interface AbonneDto {
  id: number;
  email: string;
  canal: string;
  langue: string;
  inscritLe: string;
  actif: boolean;
  categorieIds?: number[];
}

const NewsletterService = {
  subscribe: async (payload: { email: string; canal: string; langue?: string; categorieIds?: number[] }): Promise<AbonneDto> => {
    const response = await API.post("/newsletter/abonnement", payload);
    console.log(response.data.donnees);
    return response.data.donnees;
  },

  unsubscribe: async (email: string): Promise<void> => {
    await API.delete("/newsletter/desabonnement", { params: { email } });
  },

  list: async (actif = true, page = 0, taille = 50) => {
    const response = await API.get("/newsletter/abonnes", {
      params: { actif, page, taille }
    });
    return response.data.donnees;
  },

  /** Déclenche immédiatement le digest hebdomadaire (usage : test, ou renvoi manuel). */
  declencherDigestHebdomadaire: async (): Promise<void> => {
    await API.post("/newsletter/digest-hebdomadaire/declencher");
  },
};

export default NewsletterService;
